import { Stack } from '@mui/material';

export default function ProductTourContent({
  children,
  spacing,
  alignItems,
  direction = 'column'
}: {
  children: React.ReactNode;
  spacing: number;
  alignItems?: string;
  direction?: 'column' | 'row';
}) {
  return (
    <>
      <Stack
        direction={direction}
        alignItems={alignItems}
        spacing={spacing}
        sx={{ marginTop: '12px', fontSize: '12px' }}
      >
        {children}
      </Stack>
    </>
  );
}
